<template>
  <section class="login_box" :style="h_qq">
    <!-- <p class="location_nav"><span class="left">您的位置 : 
    	<router-link to="/Index">首页</router-link>
    	> 登录</span><b class="right">
      <router-link to="/Index">← 返回首页</router-link>
      </b></p> -->
    <div class="login_form">
      <div class="login_h">
        <b class="left">登录</b>
        <!-- <span class="right"><router-link to="/register" class="link_qq_login">没有账号，立即申请》</router-link></span> -->
      </div>
      <!-- <p class="login_type">
        <el-radio v-model="login_type" label="1">个人</el-radio>
        <el-radio v-model="login_type" label="2">机构</el-radio>
      </p> -->
      <div class="login_inp_box">
        <el-input
          class="login_inp auto_h"
          placeholder="用户名"
          prefix-icon="yh-wo"
          v-model="name">
        </el-input>
        <el-input
          type="password"
          class="login_inp auto_h"
          placeholder="密码"
          prefix-icon="yh-suo"
          v-model="password">
        </el-input>
        <div style="width: 100%;height: 55px;overflow: hidden;">
        	<el-input
	          class="login_inp auto_h left"
	          placeholder="验证码"
	          prefix-icon="yh-selected"
	          style="width: 132px;margin-right: 10px;"
	          v-model="code">
	        </el-input>
	        <img v-if="code_img" :src="code_img" class="code_img_box"/>
	        <a class="btn_up right" @click.prevent="get_code"><i class="yh-shuaxin"></i>刷新</a>
        </div>
        <p class="if_agree">
          <el-checkbox v-model="if_agree"></el-checkbox>
          <span>登录即默认遵守《北京社科学术数据服务平台用户协议》</span>
        </p>
        <el-button type="primary" class="login_btn" @click="login_fn">登录</el-button>
        <!-- <p class="forget_pass txt_right">
          <router-link to="/changePass">忘记密码?</router-link>
        </p> -->
      </div>
    </div>
  </section>
</template>

<script>
import { yh_get,yh_post,yh_alert } from "../api/index"
import {Md5} from "ts-md5/dist/md5";
// import { SetToken} from '@/utils/cookies'
import { setCookie,getCookie,delCookie } from '../assets/js/public'
export default {
  data () {
    return {
      height: {
        height: 0
      },
      login_type: "1",
      name: "",
      password: "",
      code: "",
      if_agree: true,
      code_img: "",
      h_qq: {
        height: 0
      }
    }
  },
  methods: {
    get_code() {
    	this.$api.axios_code("").then(res => {
	    	this.code_img = res.captchacode;
	    })
      
    },
    login_fn() {
      if(this.name == ""){
        this.$message.error("用户名不得为空");
        return;
      } 
      if(this.password == ""){
        this.$message.error("密码不得为空");
        return;
      }
      var obj = {
        name: this.name,
        password: Md5.hashStr(this.password)
      }
	    this.$api.axios_login(this.code,obj).then(res => {
	    		if(res.status === "OK"){
            localStorage.setItem("doc_token",res.result.items[0].token)
            localStorage.setItem("doc_name",res.result.items[0].name)
            localStorage.setItem("doc_userid",res.result.items[0].id)
	    			this.$store.commit("userName", this.name);
		     		this.$router.replace("/Index");
	      	}if (res.status == "FAIL") {
            if (res.errors[0].code === 1010) {
              this.$message.error("验证码错误，请重新输入");
            } else if (res.errors[0].code === 1012) {
              this.$message.error(res.errors[0].message + "。请重新输入并检查字母大小写是否正确");
            } else if (res.errors[0].code === 1018) {
              this.$message.error(res.errors[0].message);
            } else if (res.errors[0].code === 1019) {
              this.$message.error(res.errors[0].message + "，请联系管理员添加账号");
            } else {
              this.$message.error("网络异常，请检查网络状态");
            }
            this.code = ""
            this.get_code();
          }
	     		
	    })
    },
    get_h() {
				if((document.body) && (document.body.clientHeight))
				var h = document.documentElement.clientHeight - 140 + "px";
				if(h > 690) {
					this.h_qq.height = h + "px"
				} else {
					this.h_qq.height = 690 + "px"
				}
			}
  },
  mounted() {
    this.$store.commit("userName", "");
    this.get_code();
    this.get_h()
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login_box{
  /* padding-top: 30px; */
  height: 784px;
  overflow: hidden;
  width: 1000px;
  margin: 0 auto;
}
.location_nav{
  width: 100%;
  height: 20px;
  padding-top: 30px;
  line-height: 20px;
}
.login_form{
  width:530px;
  height:482px;
  background: #ffffff;
  margin: 30px auto 80px;
  padding: 30px 90px;
  box-sizing: border-box
}
.login_form{
  width:530px;
  height:482px;
  background: #ffffff;
  margin: 30px auto 80px;
  padding: 30px 90px;
  box-sizing: border-box
}
.login_h{
  height: 32px;
  line-height: 32px;
  margin-bottom: 42px;
}
.login_h b{
  font-size: 24px;
}
.login_h span{
  color: #999999
}
.login_type{
  height: 14px;
  margin-bottom: 20px;
  padding: 0;
}
.login_inp_box{
  width: 350px;

}
.login_inp{
  height: 42px;
  margin-bottom: 20px;
}
.if_agree{
  height: 18px;
  line-height: 20px;
  width: 100%;
  margin: 10px 0;
}
.if_agree span{
  font-size: 12px !important;
  color: #666666;
  margin-left: 5px;
}
.if_agree .el-checkbox{
	margin-right: 0px !important;
}
.login_btn{
  width: 350px;
  height: 50px;
  margin-bottom: 10px;
}
.forget_pass{
  height: 20px;
  line-height: 20px;
  color: #FF7223;
}
a:-webkit-any-link{
  color: #333333;
  text-decoration: none;
}
a.link_qq_login:-webkit-any-link{
  color: #999999;
  text-decoration: none;
}
.code_img_box{
	width: 148px;
	height: 42px;
	float: left;
	margin-right: 10px;
}
.btn_up{
	display: block;
	width: 46px;
	height: 42px;
	line-height: 42px;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue